import { isDefined } from "../../infra3d";
import { Tool } from "./internal";
/**
 * Snapshot Tool
 * @class SnapShotTool
 * @extends {Tool}
 */
export class SnapShotTool extends Tool {
    constructor(scene, toolhandler, options, name, group) {
        super(scene, toolhandler);
        this.canv2d = null;
        this.w = 0;
        this.h = 0;
        this.dragActive = false;
        this.x0 = 0;
        this.y0 = 0;
        this.x1 = 0;
        this.y1 = 0;
        this.textlines = [];
        this.name = name;
        this.group = group;
        const defaultoptions = {
            singleactive: false,
            enablecbf: null,
            disablecbf: null,
            snapshottakencbf: null,
            takingsnapshotcbf: null,
            activecursor: "crosshair",
            labelids: null,
            textfillstyle: "bold 11pt Arial",
            textcolor: "#FFFFFF",
            ratio: 3 / 4,
            lod: 2,
            realScreenshot: true,
            textlinespacing: 18,
        };
        for (const property in defaultoptions) {
            this.options[property] = defaultoptions[property];
        }
        super.parseOptions(options);
        this.type = "SnapShotTool";
    }
    /**
     * internal function - to activate tool call mmSnapShotTool.enable
     * @method _enableTool
     * @protected
     */
    _enableTool() {
        this.canv2d = document.createElement("canvas");
        this.canv2d.width = this.engine.getCanvas().width;
        this.canv2d.height = this.engine.getCanvas().height;
        this.canv2d.style.width = this.engine.getCanvas().width.toString();
        this.canv2d.style.height = this.engine.getCanvas().height.toString();
        this.canv2d.style.top = "0px";
        this.canv2d.style.left = "0px";
        this.canv2d.style.position = "absolute";
        this.canv2d.onmousedown = (evt) => {
            this._startDrag(evt);
        };
        this.canv2d.onmouseup = (evt) => {
            this._stopDrag(evt);
        };
        this.ctx2d = this.canv2d.getContext("2d");
        this.engine.getCanvas().parentElement.appendChild(this.canv2d);
        this._subscribeEvents();
        this.fire(SnapShotTool.enabled, this.options["cbobject"]);
        this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
    }
    /**
     * internal function - to disable tool call mmSnapShotTool.disable
     * @method _disableTool
     * @protected
     */
    _disableTool() {
        // if tool is not active there is nothing to disable...
        if (!this.enabled)
            return;
        if (this.canv2d != null) {
            this.engine.getCanvas().parentElement.removeChild(this.canv2d);
            this.canv2d = null;
        }
        this.fire(SnapShotTool.disabled, this.options["cbobject"]);
        this._unSubscribeEvents();
        this.toolstate = -1;
        this.scene.getCursorStyleHandler().setCursorStyle();
    }
    _subscribeEvents() {
        if (this.options.enablecbf != null) {
            this.on(SnapShotTool.enabled, this.options.enablecbf);
        }
        if (this.options.disablecbf != null) {
            this.on(SnapShotTool.disabled, this.options.disablecbf);
        }
        if (this.options.takingsnapshotcbf != null) {
            this.on(SnapShotTool.takingsnapshot, this.options.takingsnapshotcbf);
        }
        if (this.options.snapshottakencbf != null) {
            this.on(SnapShotTool.snapshottaken, this.options.snapshottakencbf);
        }
    }
    _unSubscribeEvents() {
        if (this.options.enablecbf != null) {
            this.off(SnapShotTool.enabled, this.options.enablecbf);
        }
        if (this.options.disablecbf != null) {
            this.off(SnapShotTool.disabled, this.options.disablecbf);
        }
        if (this.options.takingsnapshotcbf != null) {
            this.off(SnapShotTool.takingsnapshot, this.options.takingsnapshotcbf);
        }
        if (this.options.snapshottakencbf != null) {
            this.off(SnapShotTool.snapshottaken, this.options.snapshottakencbf);
        }
    }
    /**
     * internal function - starts the drag functionality
     * @method _startDrag
     * @private
     */
    _startDrag(evt) {
        this.dragActive = true;
        this.canv2d.onmousemove = (evt) => {
            this._mousemove(evt);
        };
        this.x0 = evt.offsetX; //evt.layerX;
        this.y0 = evt.offsetY; //evt.layerY;
        this.textlines = [];
        if (isDefined(this.options.labelids) && this.options.labelids != null) {
            const labelids = this.options.labelids.slice();
            labelids.reverse();
            for (let i = 0; i < labelids.length; i++) {
                this.t = document.getElementById(labelids[i]);
                if (this.t != null) {
                    if (this.t.innerHTML != "") {
                        const textline = this.t.innerHTML.replace(/(<([^>]+)>)/gi, "");
                        if (textline != "")
                            this.textlines.push(textline);
                    }
                }
            }
        }
    }
    /**
     * internal function - opens the snapshot area on mousemove
     * @method _mousemove
     * @param evt
     * @private
     */
    _mousemove(evt) {
        this.x1 = evt.offsetX; //evt.layerX;
        if (evt.ctrlKey) {
            this.y1 = evt.offsetY; //evt.layerY;
        }
        else {
            if ((this.x1 > this.x0 && evt.offsetY < this.y0) || (this.x1 < this.x0 && evt.offsetY > this.y0)) {
                this.y1 = this.y0 - (this.x1 - this.x0) / this.options.ratio;
            }
            else {
                this.y1 = this.y0 + (this.x1 - this.x0) / this.options.ratio;
            }
        }
        this.ctx2d.clearRect(0, 0, this.canv2d.width, this.canv2d.height);
        this.ctx2d.fillStyle = "rgba(0,0,0,0.4)";
        this.ctx2d.fillRect(0, 0, this.canv2d.width, this.canv2d.height);
        this.ctx2d.clearRect(this.x0, this.y0, this.x1 - this.x0, this.y1 - this.y0);
        this.ctx2d.fillStyle = "rgba(1,0,0,1)";
        this.ctx2d.fillRect(this.x0, this.y0, 2, 2);
        const lrx = Math.min(this.x0, this.x1);
        const lry = Math.max(this.y0, this.y1);
        this.ctx2d.fillStyle = this.options.textcolor;
        this.ctx2d.font = this.options.textfillstyle;
        this.ctx2d.lineWidth = 2;
        // stroke color
        this.ctx2d.strokeStyle = "black";
        for (const i in this.textlines) {
            const text = this.textlines[i];
            const lry_line = lry - 10 - parseInt(i) * this.options.textlinespacing;
            this.ctx2d.strokeText(text, lrx + 10, lry_line);
            this.ctx2d.fillText(text, lrx + 10, lry_line);
        }
    }
    /**
     * internal function - stops the drag functionality
     * @method _stopDrag
     * @param {Object} evt
     * @private
     */
    _stopDrag(evt) {
        this.dragActive = false;
        this.canv2d.onmousemove = null;
        this.fire(SnapShotTool.takingsnapshot, this.options["cbobject"], evt);
        if (this.options.realScreenshot) {
            this.exportAsPngScreenshot(evt);
        }
        else {
            this.exportAsPng(evt);
        }
    }
    /**
     * internal-function opens the defined the image in a new window
     * @method exportAsPng
     */
    exportAsPng(evt) {
        const ulx = Math.min(this.x0, this.x1);
        const uly = Math.min(this.y0, this.y1);
        const lrx = Math.max(this.x0, this.x1);
        const lry = Math.max(this.y0, this.y1);
        this.w = Math.round(lrx - ulx);
        this.h = Math.round(lry - uly);
        const geoframe = this.scene.getCurrentGeoframe();
        const mh = this.scene.getMeasureHandler();
        const p1_minfo = mh.mouseToMap(this.x0, this.y0);
        const p2_minfo = mh.mouseToMap(this.x1, this.y1);
        const p1 = p1_minfo[0].coords;
        const p2 = p2_minfo[0].coords;
        geoframe.downloadCurrentFrame(p1.x, p1.y, p2.x, p2.y, this.options.lod, (dataUrl) => {
            this.exportAsPng_cbf(dataUrl, evt);
        });
        this.disable();
    }
    /**
     * internal-function returns the defined screenshot
     * @method exportAsPngScreenshot
     * @param {Object} evt
     */
    exportAsPngScreenshot(evt) {
        const ulx = Math.min(this.x0, this.x1);
        const uly = Math.min(this.y0, this.y1);
        const lrx = Math.max(this.x0, this.x1);
        const lry = Math.max(this.y0, this.y1);
        const w = Math.round(lrx - ulx);
        const h = Math.round(lry - uly);
        this.scene.infrascene.render();
        const arr = this.engine.getImageBuffer(ulx, uly, w, h);
        const exportcanv = document.createElement("canvas");
        exportcanv.width = w;
        exportcanv.height = h;
        const exportctx = exportcanv.getContext("2d");
        // First fill the canvas with nonesense to prevent IE Problems!!!!
        exportctx.fillRect(0, 0, w, h);
        const image = this.ctx2d.getImageData(0, 0, w, h);
        for (let i = 0; i < image.data.length; i++) {
            image.data[i] = arr[i];
        }
        exportctx.putImageData(image, 0, 0);
        exportctx.fillStyle = this.options.textcolor;
        exportctx.font = this.options.textfillstyle;
        exportctx.lineWidth = 2;
        // stroke color
        exportctx.strokeStyle = "black";
        for (const i in this.textlines) {
            const text = this.textlines[i];
            const lry_line = h - 10 - parseInt(i) * this.options.textlinespacing;
            exportctx.strokeText(text, 10, lry_line);
            exportctx.fillText(text, 10, lry_line);
        }
        const dataURL = exportcanv.toDataURL("image/png");
        const img = new Image();
        img.src = dataURL;
        this.fire(SnapShotTool.snapshottaken, this.options["cbobject"], img, w, h, evt);
        this.disable();
    }
    /**
     * internal-function opens the defined the image in a new window
     * @method exportAsPng_cbf
     * @param {string} dataURL
     * @param {Object} evt
     */
    exportAsPng_cbf(dataURL, evt) {
        const img = new Image();
        img.src = dataURL;
        this.fire(SnapShotTool.snapshottaken, this.options["cbobject"], img, this.w, this.h, evt);
        this.disable();
    }
}
SnapShotTool.enabled = "enabled";
SnapShotTool.disabled = "disabled";
SnapShotTool.takingsnapshot = "takingsnapshot";
SnapShotTool.snapshottaken = "snapshottaken";
//# sourceMappingURL=snapshottool.js.map